import Vue from 'vue';

export default function checkStatisticsPermission(to, from, next) {
  const packageName = to.params.packageName;
  const hasStatistics = Vue.prototype.$auth.checkAppPermission(
    'statistics',
    packageName,
  );
  const isSudoer = Vue.prototype.$auth.user?.isSudoFromAdmin;

  if (hasStatistics || isSudoer) {
    return next();
  } else {
    return next({
      name: 'app-info',
      params: { packageName },
    });
  }
}
